import { useEffect, useMemo, useRef, useState } from "react";
import { useObjectCallback, useSheet } from "../../../../../hooks/useTheatre";
import { findObjectStartsWithKey } from "../../../../../utils/FindObjects";
import { Color, MeshStandardMaterial, PointLight, Vector3 } from "three";

import { CircularWaterStreams } from "../Water";
import SteamParticlesInstances from "../SteamParticelsBAS";
import RinginductorWater from "../RinginductorWater";
import { useThree } from "@react-three/fiber";

import fragmentShaderReplacement from "../../../shader/VertexColorHeat_replacement.glsl";
import fragmentShaderAddition from "../../../shader/VertexColorHeat_addition.glsl";

const LightName = "Vertical_Light_asdfadsfadsf";

const VerticalAnimation = ({ object3d, action, ...props }) => {
  const sheet = useSheet("EFD", "HARDLINE_VERTICAL", "0");

  const [steam1active, setsteam1active] = useState(false);
  const steam1activeRef = useRef(false);

  const waterRef = useRef();
  const waterRef2 = useRef();

  const waterTubeRef = useRef();

  const particlesRef = useRef();

  useEffect(() => {
    if (waterRef.current) {
      var target = findObjectStartsWithKey("Vertical_WaterPosition", object3d);

      target.add(waterRef.current);
      waterRef.current.position.copy(new Vector3());

      var target2 = findObjectStartsWithKey("Vertical_2WaterPosition", object3d);
      target2.add(waterRef2.current);
      waterRef2.current.position.copy(new Vector3(0, 0, 0));
    }
  }, [waterRef.current]);

  useEffect(() => {
    if (particlesRef.current) {
      var target = findObjectStartsWithKey("Vertical_LightPosition", object3d);

      target.add(particlesRef.current);
      particlesRef.current.position.copy(new Vector3());
    }
  }, [particlesRef.current]);

  const animationConfig = useMemo(() => {
    return {
      animationTime: 0,
      lightIntesity: 0,
      water: 0,
      steam1: false,
      waterTube: 0,
      hardened: 0,
    };
  }, []);

  useEffect(() => {
    action.reset().play().fadeIn(0.5);
    action.play();
    action.paused = true;
    sheet.sequence.position = 0;
    sheet.sequence.play({ iterationCount: Infinity });
    return () => {
      sheet.sequence.position = 0;
      sheet.sequence.pause();
      action.time = 0;
      action.fadeOut(0.5).stop().reset();
    };
  }, []);

  const Light = useMemo(() => {
    var l = findObjectStartsWithKey(LightName, object3d);
    if (l) return l;

    var target = findObjectStartsWithKey("Vertical_LightPosition", object3d);

    var light = new PointLight(new Color("#ff0000"), 0);

    // light.add(debugSphere);
    light.position.copy(target.position);
    light.name = LightName;
    light.distance = 0.125;
    light.decay = 1;
    target.add(light);
    light.position.copy(new Vector3());

    return light;
  }, []);

  // useEffect(() => {
  //   var stange = findObjectStartsWithKey("Hardline_Ring_Werkstueck", scene);

  //   var materialClone = stange.material.clone();

  //   var materialClone = new MeshStandardMaterial({
  //     color: 0xcccccc,
  //     metalness: 0.9,
  //     roughness: 0.2,
  //     vertexColors: true,
  //   });

  //   materialClone.uniforms = {
  //     uHeat: {
  //       value: 0.0,
  //     },
  //     uHeatFallof: {
  //       value: 0.9,
  //     },
  //     ...materialClone.uniforms,
  //   };

  //   materialClone.onBeforeCompile = (s) => {
  //     s.uniforms.uHeat = {
  //       value: 0.0,
  //     };
  //     s.uniforms.uHeatFallof = {
  //       value: 0.9,
  //     };
  //     s.uniforms.uHardened = {
  //       value: 0.0,
  //     };
  //     s.fragmentShader = `${fragmentShaderAddition}\n${s.fragmentShader}`;
  //     s.fragmentShader = s.fragmentShader.replace(
  //       `#include <color_fragment>`,
  //       ``
  //     );
  //     s.fragmentShader = s.fragmentShader.replace(
  //       `#include <dithering_fragment>`,
  //       fragmentShaderReplacement
  //     );
  //     // console.log(s.fragmentShader);
  //     materialClone.userData.shader = s;
  //   };

  //   stange.material = materialClone;
  // }, []);

  const stange = useMemo(() => {
    var stange = findObjectStartsWithKey("Hardline_Ring_Werkstueck", object3d);
    if (stange) {
      var materialClone = new MeshStandardMaterial({
        color: 0xcccccc,
        metalness: 0.9,
        roughness: 0.2,
        vertexColors: true,
      });

      materialClone.uniforms = {
        uHeat: {
          value: 0.0,
        },
        uHeatFallof: {
          value: 0.9,
        },
        ...materialClone.uniforms,
      };

      materialClone.onBeforeCompile = (s) => {
        s.uniforms.uHeat = {
          value: 0.0,
        };
        s.uniforms.uHeatFallof = {
          value: 0.9,
        };
        s.uniforms.uHardened = {
          value: 0.0,
        };
        s.fragmentShader = `${fragmentShaderAddition}\n${s.fragmentShader}`;
        s.fragmentShader = s.fragmentShader.replace(`#include <color_fragment>`, ``);
        s.fragmentShader = s.fragmentShader.replace(`#include <dithering_fragment>`, fragmentShaderReplacement);
        // console.log(s.fragmentShader);
        materialClone.userData.shader = s;
      };

      stange.material = materialClone;
    }
    return stange;
  }, [object3d]);

  useObjectCallback(
    sheet,
    "Animation",
    animationConfig,

    ({ animationTime, lightIntesity, water, steam1, waterTube, hardened }) => {
      action.time = sheet.sequence.position;
      if (Light) {
        Light.intensity = lightIntesity;
      }

      if (waterRef.current) {
        waterRef.current.scale.x = water;
        waterRef.current.scale.y = water;
        waterRef.current.scale.z = water;
        waterRef2.current.scale.x = water;
        waterRef2.current.scale.y = water;
        waterRef2.current.scale.z = water;
      }
      if (steam1activeRef.current != steam1) {
        steam1activeRef.current = steam1;
        setsteam1active(steam1);
      }
      if (waterTubeRef.current) {
        waterTubeRef.current.material.uniforms.uFadeIn.value = waterTube;
      }
      if (stange && stange.material.userData.shader) {
        stange.material.userData.shader.uniforms.uHardened.value = hardened;
      }
    },
  );

  return (
    <>
      <group ref={particlesRef}>
        <SteamParticlesInstances active={steam1active} />
      </group>
      <group ref={waterRef}>
        {/* <WaterStreams /> */}
        <CircularWaterStreams />
      </group>
      <group ref={waterRef2} rotation={[0, 0.1, 0]}>
        {/* <WaterStreams /> */}
        <CircularWaterStreams />
      </group>
      <RinginductorWater ref={waterTubeRef} parentName={"Vertical_2WaterPosition"} />
      {/* <MainSpindleTubes object3d={object3d} /> */}
    </>
  );
};

export default VerticalAnimation;
